import { create } from "zustand";

import { GetProducts, GetProductsPercentage } from "../services/products/products.service";

export const useProducts = create((set) => ({

  products: [],
  massiveProducts: [],

  initializeProducts: async () => {

    const { data, error } = await GetProducts();

    if(!data) return;

    const { data: percentages, error: errorPercentages } = await GetProductsPercentage({
      products: Object.values(data?.objArticles ?? {}).map(article => ({
        id_article: article?.article?.id_article,
        id_category: parseInt(article?.article?.id_category ?? "0"),
        id_retailer_array: article?.article?.retailers?.map(retailer => retailer?.id),
        version: article?.version
      }))
    });

    if(errorPercentages) console.log({errorPercentages});

    Object.keys(percentages).map(articleId => {

      const article = data?.objArticles?.[articleId];
      if (!article) return;

      article.percentage = percentages[articleId].percentageGeneral;

    });

    const articles = Object.values(data?.objArticles);

    if (articles) {
      set({ products: articles });
    }

    if (error) {
      console.error(error);
    }

  },

  setMassiveProducts: (massiveProducts) => set({ massiveProducts }),

}));